import { FC, memo } from 'react'
import { Button, Menu, MenuItem, Popover } from '@blueprintjs/core'
import { usePdfEditor } from './PdfEditorProvider'
import useCallbackDebounced from '../../../hooks/shared/useCallbackDebounced'
import Tooltip from '@mui/material/Tooltip'

const AddShapeButton: FC = () => {
  const { store, saving } = usePdfEditor()
  const handleAddLineClicked = useCallbackDebounced(() => {
    store.activePage?.addElement({
      type: 'line',
      x: 50,
      y: 50,
    })
  }, [store.activePage])
  const handleAddArrowClicked = useCallbackDebounced(() => {
    store.activePage?.addElement({
      type: 'line',
      x: 50,
      y: 50,
      endHead: 'arrow', // can be empty, arrow, triangle, circle, square, bar
    })
  }, [store.activePage])
  const handleAddSquareClicked = useCallbackDebounced(() => {
    store.activePage?.addElement({
      type: 'figure',
      subType: 'rect',
      x: 50,
      y: 50,
      fill: 'black',
    })
  }, [store.activePage])
  const handleAddCircleClicked = useCallbackDebounced(() => {
    store.activePage?.addElement({
      type: 'figure',
      subType: 'circle',
      x: 50,
      y: 50,
      fill: 'black',
    })
  }, [store.activePage])
  return (
    <Popover
      content={
        <Menu>
          <MenuItem icon="layout-linear" text="Line" onClick={handleAddLineClicked} />
          <MenuItem icon="arrow-right" text="Arrow" onClick={handleAddArrowClicked} />
          <MenuItem icon="square" text="Square" onClick={handleAddSquareClicked} />
          <MenuItem icon="circle" text="Circle" onClick={handleAddCircleClicked} />
        </Menu>
      }
      placement="bottom"
      disabled={saving}
    >
      <Tooltip title={'Add shapes'} placement="right">
        <Button intent="none" icon="shapes" disabled={saving} />
      </Tooltip>
    </Popover>
  )
}

export default memo(AddShapeButton)
